var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardStocks = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0V0z",
    id: "4va2fdpl3a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#4va2fdpl3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9DEE4",
    d: "m41.94 25.525-7.066 3.42-6.896-3.495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FC8D1",
    d: "m41.812 5.514 6.77 3.402 7.186-3.328L48.581 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286072",
    d: "M41.808 5.514v32.445l6.919 3.497V8.964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "m48.727 41.456 7.042-3.472V5.588l-7.042 3.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBEFD2",
    d: "m27.983 25.45 6.769 3.402 7.187-3.327-7.187-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2B559",
    d: "M27.978 25.45v32.444l6.92 3.498V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286072",
    d: "M41.808 37.959v14.04l6.976 3.841V41.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "M48.784 41.456V55.84L56 52.761l-.231-14.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1CA6F",
    d: "m34.897 61.392 7.043-3.472V25.525L34.897 28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAE0E5",
    d: "m14 52.176 6.769 3.402 7.186-3.327-7.186-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52A2BA",
    d: "M20.768 55.578V68l7.125-3.391V52.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B8C9B",
    d: "M20.768 55.578 14 52.176v12.53L20.768 68z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardStocks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-stocks.0d2c3da3d74f6e569586e8983e0d4979.svg";